import {Tabs, Title} from '@mantine/core'
import {Outlet, useNavigate, useRouterState} from '@tanstack/react-router'

type WorkersTab = 'workers' | 'types'

function isDetailRoute(pathname: string) {
    const segments = pathname.split('/').filter(Boolean)
    if (segments[0] !== 'workers') {
        return false
    }

    if (segments.length === 2 && segments[1] !== 'types') {
        return true
    }

    return segments.length === 3 && segments[1] === 'types'
}

function activeTabFromPathname(pathname: string): WorkersTab {
    if (pathname.startsWith('/workers/types')) {
        return 'types'
    }
    return 'workers'
}

function tabPath(tab: WorkersTab) {
    switch (tab) {
        case 'types':
            return '/workers/types'
        default:
            return '/workers'
    }
}

export function WorkersLayout() {
    const pathname = useRouterState({select: (state) => state.location.pathname})
    const navigate = useNavigate()
    const activeTab = activeTabFromPathname(pathname)
    const isDetail = isDetailRoute(pathname)
    const showTabs = !isDetail

    return (
        <>
            {!isDetail ? (
                <Title order={1} mb="md">
                    Workers
                </Title>
            ) : null}

            {showTabs && (
                <Tabs
                    mb="md"
                    value={activeTab}
                    onChange={(value) => {
                        if (value) {
                            void navigate({to: tabPath(value as WorkersTab)})
                        }
                    }}
                >
                    <Tabs.List>
                        <Tabs.Tab value="workers">Workers</Tabs.Tab>
                        <Tabs.Tab value="types">Types</Tabs.Tab>
                    </Tabs.List>
                </Tabs>
            )}

            <Outlet />
        </>
    )
}
